const _handlers = {};

export const registerHandler = (entryPoint, handler) => {
  if (!entryPoint || !handler) return;

  _handlers[entryPoint.toLowerCase()] = handler;
};

export const getHandler = entryPoint => {
  if (entryPoint && entryPoint[0] == '/') {
    entryPoint = entryPoint.slice(1);
  }
  return _handlers[entryPoint];
};

export const createAncMountApp = (data, locale, props, elm) => {

}
